import type { Feed, FeedEntry, UIComponent } from '~/services/layout/index.ts';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import manifest from '../config/manifest.ts';
import { PowerCell } from '../../power-cell/components/index.tsx';
import useCurrentLanguage from '~/hooks/use-current-language';
import { getComponentMarginsOnMaxWidth } from '~/utils/styles.ts';
import { isEmptyArray } from '~/services/layout/layout.ts';
import { getGroupInfoTitle } from './get-group-info-title.ts';

export default function GroupInfoV2({
  uiComponent,
  feed,
  isLoading,
  isClientStorage,
}: {
  uiComponent: UIComponent;
  feed?: Feed;
  isLoading?: boolean;
  isClientStorage?: boolean;
}): JSX.Element {
  const currentLanguage = useCurrentLanguage();

  const { rules, localizations, styles } = getPluginConfig<typeof manifest>(
    manifest,
    uiComponent,
    false,
    currentLanguage
  );

  const selectable = !!rules?.component_cells_selectable;

  const isEmptyFeed: boolean = isEmptyArray(feed?.entry) && !isLoading;

  if (uiComponent?.rules?.hide_component_if_data_is_empty && isEmptyFeed)
    return <></>;

  const title: string | undefined = getGroupInfoTitle({
    feed,
    localizations,
    isClientStorage,
  });

  const entry = isLoading
    ? undefined
    : ({
        ...feed,
        title,
      } as FeedEntry);

  return (
    <section
      className={`component-${
        uiComponent.id
      } component-classes h-fit w-screen overflow-hidden border-none ${getComponentMarginsOnMaxWidth(
        { styles }
      )} component-maximum-width`}
    >
      <PowerCell
        uiComponent={uiComponent}
        entry={entry as FeedEntry}
        selectable={selectable}
        feedRootWebLink={feed?._webLink}
      />
    </section>
  );
}
